import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import createChangeIndicatedComponent from '../create-change-indicated-component';
import { SimpleNumber } from '../simple-number';
import { Currency } from '../currency';
import Text from '../../text';
import abbrevNumber, { shouldTruncateNumber } from '../../../../utils/abbrev-number';

class AbbreviatedNumber extends PureComponent {
  static propTypes = {
    ...Text.propTypes,
    renderExactAs: PropTypes.oneOf(['number', 'currency']),
    value: PropTypes.number,
    maxDigits: PropTypes.number.isRequired,
    maxDecimals: PropTypes.number,
    maxDigitsIncludeDecimals: PropTypes.bool,
    currency: PropTypes.string
  };

  static defaultProps = {
    renderExactAs: 'number',
    maxDecimals: 2,
    maxDigitsIncludeDecimals: false,
  };

  static contextTypes = {
    intl: PropTypes.object,
  };

  renderExactValue(value, type) {
    const {
      renderProps,
      maxDecimals,
      currency
    } = this.props;

    if (type === 'currency') {
      if(currency){
        return (
          <Currency
            {...this.props}
            renderProps={renderProps}
            value={value}
            currency={currency}
          />
        );
      } else {
        return (
          <Currency
            {...this.props}
            renderProps={renderProps}
            value={value}
          />
        );
      }
    }

    return (
      <SimpleNumber
        renderProps={renderProps}
        minimumFractionDigits={0}
        maximumFractionDigits={maxDecimals}
        value={value}
      />
    );
  }

  render() {
    const {
      value,
      maxDigits,
      maxDecimals,
      maxDigitsIncludeDecimals,
      renderProps,
      renderExactAs,
      intl
    } = this.props;
    const locale = intl.locale;

    if (value == null) {
      return this.renderExactValue();
    }

    const abbreviatedNumber = abbrevNumber(value, maxDigits, maxDecimals, locale, true, maxDigitsIncludeDecimals);

    if (typeof abbreviatedNumber === 'number') {
      let type = renderExactAs;
      if (type === 'currency' && shouldTruncateNumber(value, maxDigits, maxDecimals, maxDigitsIncludeDecimals)) {
        type = 'number';
      }
      return this.renderExactValue(abbreviatedNumber, type);
    }

    return (
      <Text {...renderProps}>
        {abbreviatedNumber}
      </Text>
    );
  }
}

export default injectIntl(AbbreviatedNumber);
export const ChangeIndicatedAbbreviatedNumber = createChangeIndicatedComponent(injectIntl(AbbreviatedNumber));
